export default [
  {
    path: 'printing/event',
    name: 'PrintingEvent',
    component: () => import('@/views/Printing/Event.vue'),
    props: true,
    meta: {
      name: 'printing-event',

      middleware: 'auth',
      template: 'printing',
    },
  },
  {
    path: 'events',
    name: 'events',
    component: () => import('@/views/Event/Index.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-event',
      template: 'auth',
    },
  },
  {
    path: 'event-create/:eventTypeId',
    name: 'eventCreate',
    component: () => import('@/views/Event/Create.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-event',
      template: 'auth',
    },
  },
  {
    path: 'event-content/:eventId',
    name: 'eventContent',
    component: () => import('@/views/Event/Show.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-event',
      template: 'auth',
    },
  },
  {
    path: 'event-update/:eventId',
    name: 'eventUpdate',
    component: () => import('@/views/Event/Update.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'management-event',
      template: 'auth',
    },
  },
  {
    path: 'print-event',
    name: 'printEvent',
    component: () => import('@/views/Printing/Event.vue'),
    props: true,
    meta: {
      name: 'printEvent',
      middleware: 'auth',
      template: 'printing',
    },
  },
];
